import { Injectable, Type } from '@angular/core';
import { Store } from '@ngrx/store';
import { ReplaySubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

import * as fromCp from './store/cp.state';
import { cpSetDialogConfig, cpUpdateDialogConfig } from './store/cp.actions';

@Injectable({
    providedIn: 'root',
})
export class CpDialogService {
    param: any;

    get contents$() {
        return this.currentComponent.pipe(distinctUntilChanged());
    }

    private currentComponent = new ReplaySubject<Type<unknown> | null>(1);

    constructor(private store: Store<fromCp.RootState>) {}

    open(component: Type<unknown>, param: any, config: Partial<fromCp.CpDialogState>) {
        this.param = param;
        this.currentComponent.next(component);

        this.store.dispatch(cpSetDialogConfig({ config: { ...config, visible: true } }));
    }

    close() {
        this.param = null;
        this.currentComponent.next(null);

        this.store.dispatch(cpSetDialogConfig({ config: { visible: false } }));
    }

    setHeader(header: string) {
        this.store.dispatch(cpUpdateDialogConfig({ config: { header } }));
    }
}
